export default "__VITE_ASSET__d209A_ZO__"